var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketSeparator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 870,
    height: 60,
    viewBox: "0 0 870 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -1,
    cy: 30,
    r: 30,
    fill: "#F3F4F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 41,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 74.25,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 107.5,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 140.75,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 174,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 207.25,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 240.5,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 273.75,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 307,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 340.25,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 373.5,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 406.75,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 440,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 473.25,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 506.5,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 539.75,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 573,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 606.25,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 639.5,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 672.75,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 706,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 739.25,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 772.5,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 805.75,
    y: 26,
    width: 21.25,
    height: 8,
    rx: 4,
    fill: "#F3F4F9"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 869,
    cy: 30,
    r: 30,
    fill: "#F3F4F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketSeparator);
export default __webpack_public_path__ + "static/media/ticketSeparator.d78e591c2bd3eca50bc92bc531c2c0a2.svg";
export { ForwardRef as ReactComponent };